import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=449b4bc1"
import script from "./Legends.vue?vue&type=script&lang=js"
export * from "./Legends.vue?vue&type=script&lang=js"
import style0 from "./Legends.vue?vue&type=style&index=0&id=449b4bc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports